import React, { useEffect, useState } from 'react'
import entete from "../../../assets/img/entete_pool.png";
import PropTypes from "prop-types";
import { frenchDate, frenchDateOnly } from '../../../variables/functions';
import "../../../assets/styles/courrierTransaction.css";
import { DocumentFooter } from '../../../components/docs/DocumentFooter';
import { Image } from 'antd';
import BarreTop from '../../../components/docs/BarreTop';
import { getCompagnieLogo } from '../../../hooks/useFilesHooks';

const CourrierDeTransaction = React.forwardRef((props, ref) => {
    const [logoPreviewUrl, setLogoPreviewUrl] = useState(null);
    useEffect(() => {
        if (props?.sinistre?.contrat?.organisme?.typeOrganisme !== "POOL") {
            getCompagnieLogo(props?.sinistre?.contrat?.organisme?.code)
                .then(async (response) => {

                    const imageBytes = await response.arrayBuffer();
                    var blob = new Blob([imageBytes], { type: "image/png" });
                    var imageUrl = URL.createObjectURL(blob);
                    setLogoPreviewUrl(imageUrl);
                })
                .catch((error) => {
                    console.log(error);
                });
        }
    }, []);

    return (
        <div className="col-12" ref={ref}>
            <div class="container-fluid printable-document my-5">
                <div style={{ flexShrink: 0 }}>
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            padding: "0px 0px",
                        }}
                    >
                        {props?.sinistre?.contrat?.organisme?.typeOrganisme !== "POOL" && (
                            <Image
                                src={logoPreviewUrl}
                                style={{
                                    width: "100%",
                                    height: "105px",
                                }}
                            />
                        )}

                        <Image
                            src={entete}
                            style={{
                                width: "100%",
                                height: "105px",
                            }}
                        />
                    </div>
                    <BarreTop />
                </div>
                <div className="printable-letter">
                    <div className="header-section text-start mb-4">
                        <p>Réf : {props?.offre?.reference || "OP04/2025"}</p>
                    </div>

                    <div className="recipient-section my-5" style={{ marginLeft: '400px' }}>
                        <h6>{props?.offre?.victime?.personne?.nom} {props?.offre?.victime?.personne?.prenom}</h6>
                        {props?.offre?.victime?.representant ? <p>{props?.offre?.victime?.representant?.nom}</p> : null}
                        <p>{props?.offre?.victime?.personne?.adresse}</p>
                        <br />
                        <p className="mb-0">Lomé- TOGO</p>
                        <p className="mb-0">Lomé, le {props?.offre?.dateCourrier ? frenchDateOnly(props?.offre?.dateCourrier) : new Date().toLocaleDateString()}</p>
                    </div>

                    <div className="subject-section my-5">
                        <p><strong style={{ fontWeight: "bold", color: "black" }}> <u>Objet :</u></strong> {props?.sinistre?.numeroSinistreM ? props?.sinistre?.numeroSinistreM : props?.sinistre?.numSinistre} - {props?.sinistre?.contrat?.souscripteur?.nom} {props?.sinistre?.contrat?.souscripteur?.prenom || ""}  C/ {props?.offre?.victime?.personne?.nom} {props?.offre?.victime?.personne?.prenom || ""}</p>
                        <p>Accident du : {props?.sinistre?.dateSinistre ? frenchDate(props?.sinistre?.dateSinistre) : "-"}</p>
                    </div>

                    <div className="body-section mt-5">
                        <p>{props?.offre?.victime?.personne?.genre === "MASCULIN" ? "Monsieur" : "Madame"},</p>
                        <p>Nous venons vers vous dans l’affaire visée en marge pour vous faire tenir notre offre d’indemnité conformément aux dispositions du Code CIMA et suivant les conclusions du Docteur {props?.expertise?.expert?.nom} {props?.expertise?.expert?.prenom || ""}</p>
                        <p>Par ailleurs, nous vous informons que selon les dispositions de l’article 235 du code CIMA :</p>
                        <blockquote className="blockquote px-4 py-2 border-start border-3 border-dark">
                            <p className="mb-0">« La victime peut, par lettre recommandée avec demande d’avis de réception, dénoncer la transaction dans les quinze jours de sa conclusion pour des motifs de non-respect du présent code.</p>
                            <p className="mb-0">Toute clause de transaction par laquelle la victime abandonne son droit de dénonciation est nulle »</p>
                        </blockquote>
                        <p>Dans l’attente de votre accord,</p>
                        <p>Recevez {props?.offre?.victime?.personne?.genre === "MASCULIN" ? "Monsieur" : "Madame"}, nos salutations distinguées.</p>
                        <p className="mt-4">Pj : Notre offre, Rapport d’expertise médicale</p>
                    </div>

                    <div className="footer-section text-center mt-5 pt-5">
                        <br />
                        <br />
                        <br />
                        <br />
                        <p>{props?.sinistre?.contrat?.organisme?.responsable}</p>
                        <p>Directeur Général de {props?.sinistre?.contrat?.organisme?.raisonSociale}</p>
                    </div>
                </div>
                <footer>
                    <DocumentFooter />
                </footer>
            </div>
        </div >
    )
});

CourrierDeTransaction.propTypes = {
    offre: PropTypes.object,
    sinistre: PropTypes.object,
    expertise: PropTypes.object,
};

export default CourrierDeTransaction